export default __webpack_public_path__ + "static/media/sign-up.deb70bce.svg";